import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollReveals = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin") || window.matchMedia("(prefers-reduced-motion: reduce)").matches || !("IntersectionObserver" in window)) return;
    const candidates = Array.from(document.querySelectorAll("main h1, main h2, main h3, main p, main article, main form, main details, main .grid > div, main .grid > button, main .audience-card, main .policy-row, main .values-orbit, main .value-detail"));
    const set = new Set(candidates);
    const elements = candidates.filter((el) => {
      for (let parent = el.parentElement; parent; parent = parent.parentElement) if (set.has(parent)) return false;
      return true;
    });
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) { target.dataset.revealed = "true"; observer.unobserve(target); }
      });
    }, { threshold: 0.05 });
    elements.forEach((element, index) => {
      element.classList.add("scroll-reveal");
      element.style.setProperty("--reveal-delay", `${(index % 3) * 45}ms`);
      const rect = element.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) element.dataset.revealed = "true";
      observer.observe(element);
    });
    return () => {
      observer.disconnect();
      elements.forEach((element) => { element.classList.remove("scroll-reveal"); delete element.dataset.revealed; });
    };
  }, [pathname]);
  return null;
};